import {onFind} from "@elements/init-modules-in-scope";
import {removeClass,addClass,on,findIn, findAllIn, hasClass} from '@elements/dom-utils';

const selectors = {
    base: '.js-order-request',
    btns: '.js-order-request__btn',
    mainSection: '.js-order-request__section-main',
    sections: '.js-order-request__section',
    backBtn: '.js-order-request__btn-back',
};

export function init() {
    onFind(selectors.base, function (baseElement) {
        let btns = findAllIn(selectors.btns, baseElement);
        let main = findIn(selectors.mainSection, baseElement);
        let sections = findAllIn(selectors.sections, baseElement);
        let backBtn = findIn(selectors.backBtn, baseElement);

        btns.forEach(btn => {
            on('click', function () {
                let target = btn.getAttribute('data-target');

                sections.forEach(section => {
                    let sec = section.getAttribute('data-section');

                    if (sec === target) {
                        section.removeAttribute("hidden")
                        backBtn.removeAttribute("hidden")
                        main.setAttribute("hidden", true)
                    }
                });
            }, btn);
        });

        on('click', function(){
            sections.forEach(section => {
                section.setAttribute("hidden", true);
            })
            main.removeAttribute("hidden");
            backBtn.setAttribute("hidden", true);
        }, backBtn);
    },);
}